// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_ValidarVinculoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for planocontas/validar_vinculo endpoint
 *
 * Returns validation result and conta details
 */
import type { Planocontas_ContaRow } from './Planocontas_ContaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_ValidarVinculoResponseDados {
valid: boolean
conta: Planocontas_ContaRow
}

export type Planocontas_ValidarVinculoResponse = ApiResponse<Planocontas_ValidarVinculoResponseDados>;

registerResponseContract('Planocontas_ValidarVinculoResponse', {
  valid: { type: 'boolean', required: true },
  conta: {
    type: 'object',
    required: false,
    fields: {
      id:                     { type: 'number',  required: false },
      fechamento_mensal_id:   { type: 'number',  required: false },
      franquia_id:            { type: 'number',  required: false },
      categoria_id:           { type: 'number',  required: false },
      nome_conta:             { type: 'string',  required: false },
      operacao:               { type: 'string',  required: false },
      tipo:                   { type: 'string',  required: false },
      percentual_faturamento: { type: 'string',  required: false },
      valor_previsto:         { type: 'string',  required: false },
      valor_efetivo:          { type: 'string',  required: false },
      created_at:             { type: 'string',  required: false },
      updated_at:             { type: 'string',  required: false },
      deleted_at:             { type: 'string',  required: false },
    },
  },
})
